import React, { FC } from 'react'
import ObservationDetail from './ObservationDetail'
import ObservationList from './ObservationList'
import { ObservationBundle } from '../../../../types/FHIRTypes/Bundle'

type ObservationProps = {
  observationData: ObservationBundle;
  observationDetailId: string | undefined;
  page: string | undefined;
  isFetching: boolean;
  handleChangePage: (page: number) => void
  totalPages: number;
  currentPage: number;
}

const Observations: FC<ObservationProps> = ({ observationData, observationDetailId, page, isFetching, handleChangePage, totalPages, currentPage }) => {
  return (
    <div>
      {
        observationDetailId && page === 'Observation' ? (
          <ObservationDetail
            detailId={observationDetailId}
          />
        ) :
          <ObservationList
            observationData={observationData}
            isFetching={isFetching}
            handleChangePage={handleChangePage}
            totalPages={totalPages}
            currentPage={currentPage}
          />
      }
    </div>
  )
}

export default Observations